/**
 * @owner @Appboy/in-app-messages
 */
import { z } from "zod";
import { common } from "../common";

/**
 * Schema for survey question definitions.
 * Maps to the as_json output of Braze::Surveys::QuestionDefinitions::Base and its subclasses.
 *
 * @see Braze::Surveys::QuestionDefinitions::Base
 */
export const surveyQuestionGetSchema = z.object({
  id: common.objectId,
  question_eid: z.string(),
  question_text: z.string(),
  // shared_constants.json SURVEY.QUESTION_TYPES
  question_type: z.enum([
    "single_choice",
    "single_boolean",
    "multiple_choice",
    "free_form_text",
    "nps",
    "phone_number",
    "email",
    "single_number",
  ]),
  marked_as_deleted: z.boolean(),
  choices: z.array(z.string()).optional(),
});

/**
 * Schema for survey definitions embedded in message variations.
 * Maps to the as_json output of Braze::Surveys::SurveyDefinition.
 *
 * @see Braze::Surveys::SurveyDefinition
 */
export const surveyDefinitionGetSchema = z.object({
  id: common.objectId,
  allow_multiple_responses: z.boolean(),
  survey_questions: z.array(surveyQuestionGetSchema),
});
